import { render, staticRenderFns } from "./changeDialog.vue?vue&type=template&id=591d6fa8&"
import script from "./changeDialog.vue?vue&type=script&lang=js&"
export * from "./changeDialog.vue?vue&type=script&lang=js&"
import style0 from "./changeDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports